import React from 'react';
import { Container } from 'react-bootstrap';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import IconButton from './IconButton';

function IconButtonDemo({ children }: any) {
  return (
    <Container>
      <Container className=" mt-10">
        <h4>Icon Buttons</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <IconButton variant="primary" icon={light('house-blank')} />
          <IconButton variant="primary-outline" icon={light('house-blank')} />
          <IconButton variant="primary-shadow" icon={light('house-blank')} />
          <IconButton variant="secondary" icon={light('house-blank')} />
          <IconButton variant="secondary-outline" icon={light('house-blank')} />
          <IconButton variant="secondary-shadow" icon={light('house-blank')} />
          <IconButton variant="danger" icon={light('house-blank')} />
          <IconButton variant="danger-outline" icon={light('house-blank')} />
          <IconButton variant="danger-shadow" icon={light('house-blank')} />
          <IconButton variant="success" icon={light('house-blank')} />
          <IconButton variant="success-outline" icon={light('house-blank')} />
          <IconButton variant="success-shadow" icon={light('house-blank')} />
        </Container>
      </Container>
      <Container className=" mt-10">
        <h4>Icon Buttons Small</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <IconButton variant="primary" icon={light('house-blank')} size="sm" />
          <IconButton
            variant="primary-outline"
            icon={light('house-blank')}
            size="sm"
          />
          <IconButton
            variant="primary-shadow"
            icon={light('house-blank')}
            size="sm"
          />
          <IconButton
            variant="secondary"
            icon={light('house-blank')}
            size="sm"
          />
          <IconButton
            variant="secondary-outline"
            icon={light('house-blank')}
            size="sm"
          />
          <IconButton
            variant="secondary-shadow"
            icon={light('house-blank')}
            size="sm"
          />
          <IconButton variant="danger" icon={light('house-blank')} size="sm" />
          <IconButton
            variant="danger-outline"
            icon={light('house-blank')}
            size="sm"
          />
          <IconButton
            variant="danger-shadow"
            icon={light('house-blank')}
            size="sm"
          />
          <IconButton variant="success" icon={light('house-blank')} size="sm" />
          <IconButton
            variant="success-outline"
            icon={light('house-blank')}
            size="sm"
          />
          <IconButton
            variant="success-shadow"
            icon={light('house-blank')}
            size="sm"
          />
        </Container>
        <h4>Icon Buttons Fixed Size</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <IconButton variant="primary" icon={light('house-blank')} size="lg" />
          <IconButton
            variant="primary-outline"
            icon={light('house-blank')}
            size="lg"
          />
          <IconButton
            variant="primary-shadow"
            icon={light('house-blank')}
            size="lg"
          />
          <IconButton
            variant="secondary"
            icon={light('house-blank')}
            size="lg"
          />
          <IconButton
            variant="secondary-outline"
            icon={light('house-blank')}
            size="lg"
          />
          <IconButton
            variant="secondary-shadow"
            icon={light('house-blank')}
            size="lg"
          />
          <IconButton variant="danger" icon={light('house-blank')} size="lg" />
          <IconButton
            variant="danger-outline"
            icon={light('house-blank')}
            size="lg"
          />
          <IconButton
            variant="danger-shadow"
            icon={light('house-blank')}
            size="lg"
          />
          <IconButton variant="success" icon={light('house-blank')} size="lg" />
          <IconButton
            variant="success-outline"
            icon={light('house-blank')}
            size="lg"
          />
          <IconButton
            variant="success-shadow"
            icon={light('house-blank')}
            size="lg"
          />
        </Container>
      </Container>
      <Container className=" mt-10">
        <h4>Icon Buttons Disabled</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <IconButton variant="primary" icon={light('house-blank')} disabled />
          <IconButton
            variant="primary-outline"
            icon={light('house-blank')}
            disabled
          />
          <IconButton
            variant="primary-shadow"
            icon={light('house-blank')}
            disabled
          />
          <IconButton
            variant="secondary"
            icon={light('house-blank')}
            disabled
          />
          <IconButton
            variant="secondary-outline"
            icon={light('house-blank')}
            disabled
          />
          <IconButton
            variant="secondary-shadow"
            icon={light('house-blank')}
            disabled
          />
          <IconButton variant="danger" icon={light('house-blank')} disabled />
          <IconButton
            variant="danger-outline"
            icon={light('house-blank')}
            disabled
          />
          <IconButton
            variant="danger-shadow"
            icon={light('house-blank')}
            disabled
          />
          <IconButton variant="success" icon={light('house-blank')} disabled />
          <IconButton
            variant="success-outline"
            icon={light('house-blank')}
            disabled
          />
          <IconButton
            variant="success-shadow"
            icon={light('house-blank')}
            disabled
          />
        </Container>
      </Container>
      <Container className=" mt-10">
        <h4>Status Icon Button</h4>
        <Container className="d-flex justify-content-between align-items-center">
          <IconButton variant="status" icon={light('bell')} isStatusButton />
        </Container>
      </Container>
      <Container className=" mt-10">
        <h4>Clear Selection Icon Button</h4>
        <Container className="d-flex flex-wrap align-items-center">
          <IconButton variant="clear-selection" icon={light('xmark')} />
          <div className="indigo-row">
            <IconButton variant="clear-selection-white" icon={light('xmark')} />
          </div>
        </Container>
      </Container>
      <Container className=" mt-10">
        <h4>Icon Button Extensions</h4>
        <Container className="d-flex justify-content-between align-items-center">
          <IconButton
            variant="icon-default"
            icon={light('ellipsis')}
          ></IconButton>
          <IconButton
            variant="icon-alert"
            icon={light('info-circle')}
          ></IconButton>
          <IconButton
            variant="icon-emphasized"
            icon={light('pie-chart')}
          ></IconButton>
          <IconButton
            variant="icon-default"
            icon={light('ellipsis')}
            extLabel="With Label"
          ></IconButton>
          <IconButton
            variant="icon-alert"
            icon={light('info-circle')}
            extLabel="With Label"
          ></IconButton>
          <IconButton
            variant="icon-emphasized"
            icon={light('pie-chart')}
            extLabel="With Label"
          ></IconButton>
        </Container>
      </Container>
    </Container>
  );
}

export default IconButtonDemo;
